import { jsx as _jsx } from "react/jsx-runtime";
import dependencyInjectionInfrastructure from "./infrastructure/dependencyInjectorInfrastructure";
import dependencyInjectionApplication from "./application/dependency_injector_application";
import SearchResults from "./presentation/components/SearchResults";
import './infrastructure/i18n/i18n';
import { useLogrocket } from "./infrastructure/utils/logrocket";
function AppSearchResults() {
    dependencyInjectionInfrastructure();
    dependencyInjectionApplication();
    useLogrocket();
    const handleRemoveEditbarClass = () => {
        if (document.body.classList.contains("editbar-collection")) {
            document.body.classList.remove("editbar-collection");
        }
    };
    return (_jsx("div", { className: "App", id: "app-results", onClick: handleRemoveEditbarClass, children: _jsx(SearchResults, {}) }));
}
export default AppSearchResults;
